
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fleettrackingquotes/contact-us",
      function () {
        return require("private-next-pages/fleettrackingquotes/contact-us.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fleettrackingquotes/contact-us"])
      });
    }
  